import { render, staticRenderFns } from "./companionsPc.vue?vue&type=template&id=ed942862&scoped=true"
import script from "./companionsPc.vue?vue&type=script&lang=js"
export * from "./companionsPc.vue?vue&type=script&lang=js"
import style0 from "./companionsPc.vue?vue&type=style&index=0&id=ed942862&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed942862",
  null
  
)

export default component.exports